const irrigation_preset_vwc = {
  "irrigation_settings": {
    "irrigation_strategy": 4,
    "irrigation_p0_dry_back_abs": 40,
    "irrigation_p0_phase_timeout_minutes": 60,
    "irrigation_p0_enable": 1,
    "irrigation_p0_enable_timeout": 1,
    "irrigation_p1_shot_size_vwc_rel": 10,
    "irrigation_p1_dry_back_rel": 0,
    "irrigation_p1_wait_after_shot_minutes": 4,
    "irrigation_p1_shot_duration_timeout_minutes": 4,
    "irrigation_p1_minimum_total_shot_duration_minutes": 5,
    "irrigation_p1_phase_timeout_minute": 90,
    "irrigation_P1_vwc_auto_sp_max_duration_no_increase_seconds": 150,
    "vwc_auto_sp_max_allowed_lower": 30,
    "vwc_auto_sp_max_allowed_upper": 100,
    "irrigation_p2_offset_target_vwc": 50,
    "irrigation_p2_dry_back_abs": 40,
    "irrigation_p2_end_before_sunset": "16:30:00",
    "irrigation_p2_shot_duration_timeout_minutes": 3,
    "irrigation_p2_wait_after_shot_s": 20,
    "irrigation_p3_min_vwc_abs": 25,
    "irrigation_p3_shot_size_rel": 4,
    "irrigation_p3_min_wait_after_shot": 60
  }
};

const irrigation_preset_time = {
  "irrigation_settings": {
    "irrigation_strategy": 3,
    "irrigation_time_exec_gap_days": 0,
    "irrigation_p0_phase_timeout_minutes": 60,
    "irrigation_p0_enable": 1,
    "irrigation_p2_interval_on_duration_seconds": 240,
    "irrigation_p2_interval_off_duration_minutes": 56,
    "irrigation_p2_end_before_sunset": "16:30:00"
  },
  "irrigation_events": [
    { 
      "duration_seconds": 240,
      "enabled": true,
      "irrigation_index": -1,
      "phase": 1, 
      "start_minute_from_phase_begin": 0
    }, 
    { 
      "duration_seconds": 240,
      "enabled": true,
      "irrigation_index": -1,
      "phase": 1, 
      "start_minute_from_phase_begin": 10
    },
    {
      "duration_seconds": 240,
      "enabled": true,
      "irrigation_index": -1,
      "phase": 1,
      "start_minute_from_phase_begin": 20
    },
    {
      "duration_seconds": 120,
      "enabled": true,
      "irrigation_index": -1,
      "phase": 2,
      "start_minute_from_phase_begin": 58
    },
    {
      "duration_seconds": 120,
      "enabled": true,
      "irrigation_index": -1,
      "phase": 2,
      "start_minute_from_phase_begin": 116
    },
    {
      "duration_seconds": 120,
      "enabled": true,
      "irrigation_index": -1,
      "phase": 2,
      "start_minute_from_phase_begin": 174
    },
    {
      "duration_seconds": 120,
      "enabled": true,
      "irrigation_index": -1,
      "phase": 2,
      "start_minute_from_phase_begin": 232
    },
    {
      "duration_seconds": 120,
      "enabled": true,
      "irrigation_index": -1,
      "phase": 2,
      "start_minute_from_phase_begin": 290
    }
  ]
};

export const irrigationPresetMapping = {
  0: "---",
  1: "irrigation_vwc_preset",
  2: "irrigation_time_preset"
}

export const irrigationPresets = {
  1: irrigation_preset_vwc,
  2: irrigation_preset_time
}

export const irrigationAdaptiveDefaults = {
  irrigation_p2_adaptive_enabled: 1,
  irrigation_p2_learning_enabled: 1,
  irrigation_p2_refill_soak_seconds: 120,
  irrigation_p2_max_total_watering_seconds: 360
};
